// extracted by mini-css-extract-plugin
module.exports = {"UiActionsToggleModal__Actions":"styles_UiActionsToggleModal__Actions__1EIRq","UiActionsToggleModal__Action":"styles_UiActionsToggleModal__Action__1w6Y7"};